import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import { usePromptDismissal, getDismissedAt } from 'find-and-filter-data/contextual-prompts/public';
import { SLAStatus } from 'conversations-internal-schema/sla/constants/enums';
import { useRef } from 'react';
import { KnowledgeBaseLinks } from '../constants/ExternalLinks';
import PreviewCardSLAIcon from './PreviewCardSLAIcon';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { Spacer } from 'foundations-components/components/Spacer';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INBOX_SLA_TOUR = 'INBOX_SLA_TOUR';
const InboxSLAOnboardingModal = ({
  children,
  onInboxSLATourOpen,
  onInboxSLATourClose
}) => {
  const hasTrackedInboxSLATourView = useRef(false);
  const {
    asyncPromptData,
    dismissPrompt
  } = usePromptDismissal(INBOX_SLA_TOUR);
  const allRequestsResolved = isSucceeded(asyncPromptData);
  const userPromptData = getData(asyncPromptData);
  if (!allRequestsResolved || !userPromptData) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const shouldHideModal = getDismissedAt(userPromptData) > 0;
  if (shouldHideModal) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  if (!hasTrackedInboxSLATourView.current) {
    onInboxSLATourOpen();
    hasTrackedInboxSLATourView.current = true;
  }
  const handleClose = () => {
    onInboxSLATourClose();
    dismissPrompt().catch(error => {
      reportError({
        error
      });
    });
  };
  const handleOpenChange = event => {
    if (event.currentTarget && !event.currentTarget.value) {
      handleClose();
    }
  };
  return /*#__PURE__*/_jsx(Popover, {
    open: true,
    showCloseButton: true,
    closeOnOutsideClick: false,
    onOpenChange: handleOpenChange,
    onCloseComplete: handleClose,
    use: "shepherd",
    placement: "right bottom",
    inlineSize: "400px",
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.title"
        })
      }),
      body: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Flex, {
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.description_top"
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(PreviewCardSLAIcon, {
              status: SLAStatus.IN_SLA
            }), /*#__PURE__*/_jsx(Spacer, {
              space: "300",
              display: "inline-block"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.icon_description_sla_default"
            })]
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "300"
          }), /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(PreviewCardSLAIcon, {
              status: SLAStatus.SLA_WARNING
            }), /*#__PURE__*/_jsx(Spacer, {
              space: "300",
              display: "inline-block"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.icon_description_sla_warning"
            })]
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "300"
          }), /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(PreviewCardSLAIcon, {
              status: SLAStatus.BREACHED
            }), /*#__PURE__*/_jsx(Spacer, {
              space: "300",
              display: "inline-block"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.icon_description_sla_breached"
            })]
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "300"
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          paddingBlockEnd: "200",
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.description_jsx",
              elements: {
                UILink: Link,
                br: 'br'
              },
              options: {
                href: KnowledgeBaseLinks.INBOX_SLA,
                external: true
              }
            })
          })
        })]
      }),
      footer: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleClose,
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.preview-card.InboxSLATourModal.gotIt"
        })
      })
    },
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
InboxSLAOnboardingModal.displayName = 'InboxSLAOnboardingModal';
export default InboxSLAOnboardingModal;